import Knowledge from "./components/KnowledgeTrash";

export default Knowledge;
